import React, { useMemo } from "react";
import ReactApexChart from "react-apexcharts";

/**
 * Komponen Chart untuk menampilkan trend stok
 * @param {Array} data - Data stok dari API (bulan, total_masuk, total_keluar, stok_netto)
 */
export default function StockChart({ data }) {
  const monthsFallback = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "Mei",
    "Jun",
    "Jul",
    "Agu",
    "Sep",
    "Okt",
    "Nov",
    "Des",
  ];

  const chartData = useMemo(() => {
    if (!data || data.length === 0) {
      return {
        categories: monthsFallback,
        series: [
          { name: "Total Masuk", type: "column", data: new Array(12).fill(0) },
          { name: "Total Keluar", type: "column", data: new Array(12).fill(0) },
          { name: "Stok Netto", type: "line", data: new Array(12).fill(0) },
        ],
      };
    }

    const hasTrendFields = data.some(
      (item) => item.label_bulan !== undefined || item.bulan !== undefined
    );

    if (!hasTrendFields) {
      return {
        categories: monthsFallback,
        series: [
          { name: "Total Masuk", type: "column", data: new Array(12).fill(0) },
          { name: "Total Keluar", type: "column", data: new Array(12).fill(0) },
          { name: "Stok Netto", type: "line", data: new Array(12).fill(0) },
        ],
      };
    }

    const categories = data.map((item) => item.label_bulan || item.bulan || "");
    const seriesMasuk = data.map((item) => Number(item.total_masuk) || 0);
    const seriesKeluar = data.map((item) => Number(item.total_keluar) || 0);
    const seriesNetto = data.map((item) => Number(item.stok_netto) || 0);

    return {
      categories,
      series: [
        { name: "Total Masuk", type: "column", data: seriesMasuk },
        { name: "Total Keluar", type: "column", data: seriesKeluar },
        { name: "Stok Netto", type: "line", data: seriesNetto },
      ],
    };
  }, [data]);

  const options = {
    chart: {
      height: 350,
      type: "line",
      toolbar: {
        show: false,
      },
    },
    stroke: {
      curve: "straight",
      width: [0, 0, 2],
    },
    dataLabels: {
      enabled: true,
      enabledOnSeries: [2],
      style: {
        fontSize: "10px",
        fontWeight: 500,
      },
    },
    xaxis: {
      type: "category",
      categories: chartData.categories,
      labels: {
        rotate: -45,
      },
    },
    yaxis: {
      title: {
        text: "Jumlah",
      },
    },
    colors: ["#4D53E0", "#FF5668", "#43BC13"],
    legend: {
      position: "top",
    },
    plotOptions: {
      bar: {
        columnWidth: "45%",
      },
    },
  };

  return (
    <ReactApexChart
      options={options}
      series={chartData.series}
      type="line"
      height={350}
    />
  );
}
